module.exports = __webpack_public_path__ + "img/20200702_172310.aaf2abed.jpg";